import { render, staticRenderFns } from "./updataIssue.vue?vue&type=template&id=1580110a&scoped=true"
import script from "./updataIssue.vue?vue&type=script&lang=js"
export * from "./updataIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1580110a",
  null
  
)

export default component.exports